import { useEffect } from "react"
import { useLocation, useSearch } from "wouter"
import cx from "clsx"
import { paths } from "../../../paths"
import { SafeExitButton } from "../../../components/SafeExitButton"
import { HappyLayout } from "../../../components/HappyLayout"
import typography from "@rawa/ui/styles/typography.module.css"
import SunnyHappy from "../../../assets/sunny-happy.svg?react"
import styles from "./ThankYouPage.module.scss"
import { ButtonLink } from "../../../components/ButtonLink"

const WAIT_BEFORE_REDIRECT_IN_MS = 5000

export function ThankYouPage() {
  const [, navigate] = useLocation()
  const search = useSearch()
  const returnTo = new URLSearchParams(search).get("return")

  useEffect(() => {
    if (returnTo !== "kiosk") return
    const timer = setTimeout(
      () => navigate(paths.kioskWelcome),
      WAIT_BEFORE_REDIRECT_IN_MS,
    )
    return () => clearTimeout(timer)
  }, [returnTo, navigate])

  return (
    <HappyLayout
      heading={
        <h1 className={cx(typography.hero, styles.heading)}>Thank you!</h1>
      }
    >
      <div className={styles.content}>
        <p className={typography.bodyLarge}>We appreciate your feedback.</p>
        <SunnyHappy className={styles.sunnyHappy} aria-hidden={true} />
        {returnTo == "kiosk" ? (
          <ButtonLink href={paths.kioskWelcome} className={styles.btnReturn}>
            Return to home screen
          </ButtonLink>
        ) : (
          <SafeExitButton />
        )}
      </div>
    </HappyLayout>
  )
}
